import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer className="text-white py-16 px-6" style={{background: 'linear-gradient(to right, rgb(15 23 42), #1d476a)'}}>
      <div className="max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start mb-4">
              <h3 className="text-2xl font-bold text-white">takeatrip NYC</h3>
            </div>
          </div>

          {/* Connect */}
          <div className="text-center">
            <h4 className="text-lg font-bold mb-4" style={{color: '#93c5fd'}}>Connect With Us</h4>
            <div className="flex flex-col items-center">
              {/* QR Code for Instagram */}
              <div className="bg-white p-3 rounded-lg mb-2">
                <img 
                  src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://instagram.com/takeatripnyc" 
                  alt="Instagram QR Code" 
                  className="w-20 h-20"
                />
              </div>
              <p className="text-slate-300 text-sm">Scan to follow @takeatripnyc</p>
            </div>
          </div>

          {/* Mission */}
          <div className="text-center md:text-right">
            <h4 className="text-lg font-bold mb-4" style={{color: '#93c5fd'}}>Our Mission</h4>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Building communities through shared adventures and culturally aligned experiences.
            </p>
            
            {/* Policy Links */}
            <div className="flex flex-col space-y-2">
              <Link to="/terms" className="text-slate-400 text-sm hover:text-slate-200 transition-colors duration-300">
                Terms & Conditions
              </Link>
              <Link to="/refund-policy" className="text-slate-400 text-sm hover:text-slate-200 transition-colors duration-300">
                Refund Policy
              </Link>
              <Link to="/privacy-policy" className="text-slate-400 text-sm hover:text-slate-200 transition-colors duration-300">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700/50 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm mb-4 md:mb-0">
              © 2025 takeatrip NYC. Take a trip that will build more than memories.
            </p>
            <div className="flex items-center text-slate-400 text-sm">
              Made with <Heart className="w-4 h-4 mx-1" style={{color: '#93c5fd'}} /> in NYC
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;